import { render, staticRenderFns } from "./CalcConfigForm.vue?vue&type=template&id=0c006bb2&"
import script from "./CalcConfigForm.vue?vue&type=script&lang=js&"
export * from "./CalcConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports